export let STREAM_STATES;
(function (STREAM_STATES) {
  STREAM_STATES["CREATED"] = "created";
  STREAM_STATES["STREAMING"] = "streaming";
  STREAM_STATES["PENDING_RECONNECT"] = "pending_reconnect";
  STREAM_STATES["CLOSED"] = "closed";
})(STREAM_STATES || (STREAM_STATES = {}));
//# sourceMappingURL=stream-states.js.map